import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-exportfield-dropdown',
  templateUrl: './ExportFieldDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => ExportFieldDropdownComponent)}]
})
export class ExportFieldDropdownComponent extends BaseDropdownComponent {

    constructor(private exportService: serv.ExportService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.exportService.getExportFields().subscribe(x=> this.onGetRecordsDone(x));
    }
    
    onGetRecordsDone(items: ent.ExportField[]){
        this.selectItems = [];
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:`${y.ID} - ${y.Header}`, value:y.ID}));
        this.value = this.selectedID;
    }

}